document.addEventListener("DOMContentLoaded", (event) => {

    const carousel = document.querySelectorAll('.experts-carousel');

    if (carousel) {
        carousel.forEach(carousel_block => {

            const list = carousel_block.querySelector('.experts-grid');
            const next = carousel_block.querySelector('.experts-carousel__next-btn') || null;
            const prev = carousel_block.querySelector('.experts-carousel__prev-btn') || null;
            const nav_container = carousel_block.querySelector('.experts-carousel__nav') || null;

            const swiper = new Swiper(list, {
                loop: true,
                loopPreventsSliding: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                on: {
                    init: function () { toggleCustomNavigation(this, nav_container); },
                    resize: function () { toggleCustomNavigation(this, nav_container); },
                },
                slidesPerView: 1.15,
                spaceBetween: 20,
                autoHeight: true,
                breakpoints: {

                    500: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    748: {
                        slidesPerView: 2.1,
                        spaceBetween: 16,
                    },
                    991: {
                        slidesPerView: 2.5,
                        spaceBetween: 31,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 31,
                    }
                }
            });

        });

        function toggleCustomNavigation(swiperInstance, nav_container) {
            if (swiperInstance.params.navigation && nav_container) {
                if (swiperInstance.slides.length <= swiperInstance.params.slidesPerView) {
                    nav_container.style.display = 'none';
                } else {
                    nav_container.style.display = 'flex';
                }
            }
        }
    }

});
